import { render, staticRenderFns } from "./BlogSaved.vue?vue&type=template&id=5ab79071&"
import script from "./BlogSaved.vue?vue&type=script&lang=js&"
export * from "./BlogSaved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports